import { ReloadOutlined } from "@ant-design/icons";
import { Button, Card, Table } from "antd";
import { SorterResult } from "antd/lib/table/interface";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ICmsItem, IFiltersCms } from "../../api/dto/cms/ICmsItem";
import { onChangeDataTable, onChangePaginationTable } from "../../common/helpers/tablesPropsHelpers";
import { StateType, useAppDispatch } from "../../core/redux/store";
import { getAllCmsDataThunk } from "../../modules/cms/cmsActionAsync";
import { selectAllCmsEntities, selectCmsById } from "../../modules/cms/cmsSelector";
import { ContentStyled, FiltersButtonBlock, HeaderStyled, TitleStyled } from "../../ui/commonComponents";
import { FiltersHeaderBase } from "../../ui/customFilters/FiltersHeaderBase";
import { Loader } from "../../ui/Loader";
import { GenerateCmsColumns } from "../../ui/tableColumnsGenerator/cms/generateCmsColumns";
import { SectionForm } from "./components/SectionForm";

export const SectionsLayout = ({ access }: { access: boolean }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [filterValues, setFilterValues] = useState<IFiltersCms>({
    title: "",
    pagination: 1
  });
  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [activeSectionId, setActiveSectionId] = useState<string>();
  const cmsData = useSelector(selectAllCmsEntities);
  const cmsItem = useSelector((state: StateType) => selectCmsById(state, activeSectionId || ""));
  const isLoading = useSelector((state: StateType) => state.cms.isLoading);

  const showFormHandle = (id: string) => {
    setActiveSectionId(id);
    setIsShowForm(true);
  };

  const closeFormHandle = () => {
    setIsShowForm(false);
  };
  const fetchData = () => {
    dispatch(getAllCmsDataThunk(filterValues.title));
  };

  const changeSearchFilters = useCallback(
    debounce((_, title: string) => {
      setFilterValues((prev) => ({ ...prev, title }));
    }, 300),
    []
  );

  const columns = GenerateCmsColumns({ showForm: showFormHandle });

  useEffect(() => {
    fetchData();
  }, [filterValues]);

  return (
    <>
      {isLoading && <Loader />}
      <HeaderStyled>
        <TitleStyled level={4}>{t("sections.sections")}</TitleStyled>
        <Button onClick={fetchData} type="primary" icon={<ReloadOutlined />}>
          {t("common.buttonsText.refresh")}
        </Button>
      </HeaderStyled>
      <ContentStyled>
        <Card>
          <FiltersButtonBlock>
            <FiltersHeaderBase
              placeholder={t("common.filters.placeholders.title")}
              name={"title"}
              onChange={changeSearchFilters}
              resetFilters={() =>
                setFilterValues({
                  title: "",
                  pagination: 1
                })
              }
              isDisabledResetFilters={false}
            />
          </FiltersButtonBlock>
          <Table
            columns={columns}
            dataSource={cmsData}
            onChange={(pagination, filters, sorter: SorterResult<ICmsItem> | SorterResult<ICmsItem>[]) =>
              onChangeDataTable<ICmsItem, IFiltersCms>(pagination, sorter, filterValues, setFilterValues)
            }
            pagination={onChangePaginationTable(cmsData.length, filterValues.pagination)}
          />
        </Card>
      </ContentStyled>
      <SectionForm isOpen={isShowForm} onClose={closeFormHandle} cmsItem={cmsItem} searchName={filterValues.title} />
    </>
  );
};
